import AddIcon from '@mui/icons-material/Add';
import AppsIcon from '@mui/icons-material/Apps';
import BarChartIcon from '@mui/icons-material/BarChart';
import CloseIcon from '@mui/icons-material/Close';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import DoNotDisturbOffIcon from '@mui/icons-material/DoNotDisturbOff';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PeopleIcon from '@mui/icons-material/People';
import {
  Avatar,
  Badge,
  Box,
  Button,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import IntegrationsDialog from 'src/components/integrations/IntegrationsDialog';
import {
  disableNotifications,
  enableNotifications,
  selectNotificationsEnabled,
} from 'src/features/account/notifications.slice';
import {
  fetchChunks,
  selectChunksByStatus,
} from 'src/features/chunks/chunks.slice';
import { toggleCreateChannelDialog } from 'src/features/theme/theme.slice';
import { useAppDispatch, useAppSelector } from 'src/store';
import { useColorMode } from 'src/theme/ThemeProvider';
import { getBranding } from 'src/utils/branding';
import ChannelsList from '../Channels/ChannelsList';
import SimpleChannelCreate from '../Channels/create/SimpleChannelCreate';
import { MasqueradeIndicator } from '../Masquerade/MasqueradeIndicator';
import ChunksManagementDialog from '../chunks/ChunksManagementDialog';
import { CreditsSection } from './CreditsSection';

const drawerWidth = 260;
const collapsedWidth = 64;

const DarkNav = ({ upgradePlan, user, userLogOut }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { channels } = useAppSelector((state) => state.channels);
  const { activeProSubscriber } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const { activePage } = useAppSelector((state) => state.theme);
  const notificationsEnabled = useAppSelector(selectNotificationsEnabled);
  const pendingChunks = useAppSelector((state) =>
    selectChunksByStatus(state, 'pending_admin_approval')
  );
  const oppyNoMouth = getBranding('oppy_expressions_no_mouth');
  const oppyConversationIcon = getBranding('oppy_conversation_icon');
  const oppyWordMarkYellow = getBranding('oppy_word_mark_yellow');
  const oppyWordMarkBlue = getBranding('oppy_word_mark');
  const [oppiesOpen, setOppiesOpen] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [isIntegrationsDialogOpen, setIsIntegrationsDialogOpen] =
    useState(false);
  const [isChunksDialogOpen, setIsChunksDialogOpen] = useState(false);
  const theme = useTheme();
  const { mode, toggleColorMode } = useColorMode();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 900);
      //setIsMobile(true);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // fetch pending chunks on component mount
  useEffect(() => {
    dispatch(
      fetchChunks({
        chunk_type: 'rule',
        status: 'pending_admin_approval',
        per_page: 50,
      })
    )
      .then((result: any) => {
        console.log('Chunks fetch result:', result);
        console.log('Payload:', result.payload);
      })
      .catch((error: any) => {
        console.error('Chunks fetch error:', error);
      });
  }, [dispatch]);

  const handleDrawerToggle = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
    if (!newExpandedState) {
      setOppiesOpen(false);
    }
  };

  const handleListItemClick = (activePage) => {
    if (activePage !== 'Oppies') {
      if (isMobile) {
        setIsExpanded(false);
      }
      setOppiesOpen(false);
    }
    // const downcased = activePage?.toLowerCase();
    // dispatch(setActivePageString(downcased));
    // if (activePage === "Oppies") {
    //   dispatch(toggleChannelsList());
    // }
  };

  const handleUpgradePlan = () => {
    if (typeof upgradePlan === 'function') {
      upgradePlan();
    }
  };

  const handleOppiesClick = () => {
    setOppiesOpen(!oppiesOpen);
  };

  // Function to toggle the integrations dialog
  const toggleIntegrationsDialog = () => {
    console.log('Toggling integrations dialog'); // Debugging log
    setIsIntegrationsDialogOpen((prevState) => !prevState); // Use prevState for toggling
  };

  const handleDarkModeToggle = () => {
    toggleColorMode();
  };

  const handleDndToggle = () => {
    if (notificationsEnabled) {
      dispatch(disableNotifications());
    } else {
      dispatch(enableNotifications());
    }
  };

  const handleChunksClick = () => {
    setIsChunksDialogOpen(true);
  };

  const drawer = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: theme.palette.background.glassHeavy,
        color: theme.palette.mode === 'light' ? '#00000099' : '#bdbdbd',
        width: isExpanded || isMobile ? drawerWidth : collapsedWidth,
        transition: 'width 0.3s ease-in-out',
      }}
      onMouseEnter={() => !isMobile && setIsExpanded(true)}
      onMouseLeave={() => !isMobile && setIsExpanded(false)}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
        }}
      >
        <Box sx={{ position: 'relative', height: '32px', width: '100%' }}>
          <img
            style={{
              height: '32px',
              position: 'absolute',
              opacity: isExpanded ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
            }}
            src={
              theme.palette.mode === 'light'
                ? oppyWordMarkBlue
                : oppyWordMarkYellow
            }
            alt="Logo"
          />
          <img
            style={{
              height: '32px',
              position: 'absolute',
              opacity: isExpanded ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out',
            }}
            src={oppyNoMouth}
            alt="Logo"
          />
        </Box>
        {isMobile && (
          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              display: isMobile ? 'block' : 'none',
              color: theme.palette.mode === 'light' ? '#00000099' : '#bdbdbd',
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <IconButton
          onClick={toggleIntegrationsDialog} // Open integrations dialog
          sx={{
            display: { sm: 'none' },
            color: theme.palette.text.secondary,
          }}
        >
          <AppsIcon /> {/* Corrected icon */}
        </IconButton>
      </Box>

      <List>
        <ListItemButton
          onClick={handleOppiesClick}
          sx={{
            justifyContent: 'center',
            height: '48px',
            px: isExpanded ? 2 : 0,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: isExpanded ? 2 : 0,
              justifyContent: 'center',
            }}
          >
            <img
              src={oppyNoMouth}
              alt="Oppies"
              style={{ width: '24px', height: '24px' }}
            />
          </ListItemIcon>
          {isExpanded && (
            <>
              <ListItemText
                primary="Oppies"
                sx={{
                  '& .MuiTypography-root': {
                    fontFamily: 'Power Grotesk, sans-serif',
                  },
                }}
              />
              {oppiesOpen ? <ExpandLess /> : <ExpandMore />}
            </>
          )}
        </ListItemButton>
        <Collapse in={oppiesOpen && isExpanded} timeout="auto" unmountOnExit>
          <Box sx={{ pl: 2, pr: 2, overflowY: 'auto' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <Button
                variant="outlined"
                onClick={() => dispatch(toggleCreateChannelDialog())}
                sx={{
                  fontFamily: 'Power Grotesk, sans-serif',
                  height: '40px',
                  color:
                    theme.palette.mode === 'dark'
                      ? '#F2CB05'
                      : theme.palette.secondary.main,
                  borderColor:
                    theme.palette.mode === 'dark'
                      ? '#F2CB05'
                      : theme.palette.secondary.main,
                  '&:hover': {
                    bgcolor: theme.palette.action.hover,
                    borderColor:
                      theme.palette.mode === 'dark'
                        ? '#F2CB05'
                        : theme.palette.secondary.main,
                  },
                }}
              >
                Create
                <AddIcon fontSize="small" />
              </Button>
            </Box>
            <ChannelsList variant="list" />
          </Box>
        </Collapse>
        {[
          {
            text: 'Conversations',
            icon: (
              <img
                src={oppyConversationIcon}
                alt="Conversations"
                style={{ width: '24px', height: '24px' }}
              />
            ),
            to: '/conversations',
            page: 'conversations',
          },
          {
            text: 'Contacts',
            icon: (
              <PeopleIcon
                sx={{
                  color: theme.palette.mode === 'light' ? '#000000de' : 'white',
                }}
              />
            ),
            to: '/contacts',
            page: 'contacts',
          },
          {
            text: 'Analytics',
            icon: (
              <BarChartIcon
                sx={{
                  color: theme.palette.mode === 'light' ? '#000000de' : 'white',
                }}
              />
            ),
            to: '/analytics',
            page: 'analytics',
          },
          ...(user.role === 11
            ? [
                {
                  text: 'Dashboard',
                  icon: (
                    <DashboardIcon
                      sx={{
                        color:
                          theme.palette.mode === 'light'
                            ? '#000000de'
                            : 'white',
                      }}
                    />
                  ),
                  to: '/dashboard',
                  page: 'dashboard',
                },
              ]
            : []),
        ].map((item) => (
          <ListItemButton
            key={item.text}
            component={Link}
            to={item.to}
            disabled={
              item.text !== 'Oppies' &&
              item.text !== 'Settings' &&
              !channels.length
            }
            selected={activePage === item.page}
            onClick={() => handleListItemClick(item.text)}
            sx={{
              '&.Mui-selected': { bgcolor: theme.palette.action.selected },
              justifyContent: 'center',
              height: '48px',
              px: isExpanded ? 2 : 0,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: isExpanded ? 2 : 0,
                justifyContent: 'center',
              }}
            >
              {item.icon}
            </ListItemIcon>
            {isExpanded && (
              <ListItemText
                primary={item.text}
                sx={{
                  '& .MuiTypography-root': {
                    fontFamily: 'Power Grotesk, sans-serif',
                  },
                }}
              />
            )}
          </ListItemButton>
        ))}
        <ListItemButton
          onClick={toggleIntegrationsDialog} // Open integrations dialog
          sx={{
            justifyContent: 'center',
            height: '48px',
            px: isExpanded ? 2 : 0,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: isExpanded ? 2 : 0,
              justifyContent: 'center',
            }}
          >
            <AppsIcon
              sx={{
                color: theme.palette.mode === 'light' ? '#00000099' : '#9e9e9e',
              }}
            />
          </ListItemIcon>
          {isExpanded && (
            <ListItemText
              primary="Integrations"
              sx={{
                '& .MuiTypography-root': {
                  fontFamily: 'Power Grotesk, sans-serif',
                },
              }}
            />
          )}
        </ListItemButton>
      </List>

      <Box
        sx={{
          mt: 'auto',
          p: 2,
          borderTop: 1,
          borderColor: theme.palette.divider,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            sx={{ display: 'flex', alignItems: 'center', pl: '5px', gap: 2 }}
          >
            <Tooltip
              title={
                pendingChunks.length > 0
                  ? `${pendingChunks.length} pending rules`
                  : 'Rules management'
              }
            >
              <IconButton
                onClick={handleChunksClick}
                sx={{
                  p: 0,
                  color:
                    theme.palette.mode === 'light' ? '#000000de' : '#E6E6FA',
                  '&:hover': {
                    color:
                      theme.palette.mode === 'light'
                        ? theme.palette.secondary.main
                        : '#007AA5',
                  },
                }}
              >
                <Badge
                  badgeContent={pendingChunks.length}
                  color="error"
                  sx={{
                    '& .MuiBadge-badge': {
                      ...(pendingChunks.length > 0 && {
                        animation: 'pulse 2s infinite',
                        '@keyframes pulse': {
                          '0%': { opacity: 1 },
                          '50%': { opacity: 0.5 },
                          '100%': { opacity: 1 },
                        },
                      }),
                    },
                  }}
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            </Tooltip>

            <Tooltip
              title={
                notificationsEnabled
                  ? 'Enable Do Not Disturb'
                  : 'Disable Do Not Disturb'
              }
            >
              <IconButton
                onClick={handleDndToggle}
                sx={{
                  p: 0,
                  color: !notificationsEnabled
                    ? theme.palette.error.main
                    : theme.palette.mode === 'light'
                    ? '#000000de'
                    : '#E6E6FA',
                  '&:hover': {
                    color:
                      theme.palette.mode === 'light'
                        ? theme.palette.secondary.main
                        : '#007AA5',
                  },
                }}
              >
                {!notificationsEnabled ? (
                  <DoNotDisturbIcon />
                ) : (
                  <DoNotDisturbOffIcon />
                )}
              </IconButton>
            </Tooltip>

            <Tooltip
              title={mode === 'dark' ? 'Enable light mode' : 'Enable dark mode'}
            >
              <IconButton
                onClick={handleDarkModeToggle}
                sx={{
                  p: 0,
                  color:
                    theme.palette.mode === 'light' ? '#000000de' : '#E6E6FA',
                  '&:hover': {
                    color:
                      theme.palette.mode === 'light'
                        ? theme.palette.secondary.main
                        : '#007AA5',
                  },
                }}
              >
                {mode === 'dark' ? (
                  <LightbulbOutlinedIcon />
                ) : (
                  <LightbulbIcon />
                )}
              </IconButton>
            </Tooltip>
          </Box>

          {/* Masquerade Indicator - Only shown when masquerading */}
          <MasqueradeIndicator isExpanded={isExpanded} />

          {/* Credits Section */}
          {/* <CreditsSection isExpanded={isExpanded} /> */}

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              component={Link}
              to="/profile"
              sx={{
                width: 34,
                height: 34,
                mr: isExpanded ? 2 : 0,
                '& img': { objectFit: 'cover' },
              }}
              src={user.picture}
              alt="Profile Picture"
            />
            {isExpanded && (
              <Box>
                <Typography
                  variant="body2"
                  component={Link}
                  to="/profile"
                  sx={{
                    color:
                      theme.palette.mode === 'light' ? '#000000de' : '#bdbdbd',
                    fontWeight: 600,
                    fontFamily: 'Power Grotesk, sans-serif',
                  }}
                >
                  {user.name}
                </Typography>
                <Typography
                  variant="caption"
                  onClick={userLogOut}
                  sx={{
                    color:
                      theme.palette.mode === 'light' ? '#00000099' : '#9e9e9e',
                    cursor: 'pointer',
                    display: 'block',
                    fontFamily: 'Power Grotesk Light, sans-serif',
                  }}
                >
                  Sign Out
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
        {/* {!activeProSubscriber && isExpanded && (
          <Box
            onClick={handleUpgradePlan}
            sx={{
              cursor: 'pointer',
              p: 2,
              borderRadius: 2,
              bgcolor: 'primary.main',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
              position: 'relative',
              height: '40px',
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: 'white',
                fontWeight: 800,
                fontFamily: 'Power Grotesk, sans-serif',
                position: 'absolute',
                opacity: isExpanded ? 1 : 0,
                transition: 'opacity 0.3s ease-in-out',
                width: '100%',
                textAlign: 'center',
              }}
            >
              Upgrade to PRO
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                color: 'white',
                fontWeight: 800,
                fontFamily: 'Power Grotesk, sans-serif',
                position: 'absolute',
                opacity: isExpanded ? 0 : 1,
                transition: 'opacity 0.3s ease-in-out',
                width: '100%',
                textAlign: 'center',
              }}
            >
              PRO
            </Typography>
          </Box>
        )} */}
      </Box>
    </Box>
  );

  return (
    <>
      {isMobile && (
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{
            position: 'fixed',
            bottom: 32,
            left: 24,
            zIndex: 1200,
            bgcolor: '#2C2B3E',  // Dark purple/gray to stand out
            color: '#FFD700',  // Yellow Oppy brand color for icon
            width: 56,   // Large and prominent
            height: 56,
            boxShadow: '0 4px 16px rgba(0,0,0,0.5)',  // Strong shadow
            border: '2px solid rgba(255,215,0,0.2)',  // Subtle golden border
            '&:hover': { 
              bgcolor: '#3D3AC9',  // Oppy blue on hover
              color: 'white',
              transform: 'scale(1.08)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.6)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <MenuIcon sx={{ fontSize: 32 }} />  {/* Made icon even bigger to pop */}
        </IconButton>
      )}
      <Box
        component="nav"
        sx={{
          width: isMobile ? 0 : isExpanded ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          transition: 'width 0.3s ease-in-out',
        }}
      >
        <Drawer
          variant={isMobile ? 'temporary' : 'permanent'}
          open={isMobile ? isExpanded : true}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: isMobile
                ? drawerWidth
                : isExpanded
                ? drawerWidth
                : collapsedWidth,
              transition: 'width 0.3s ease-in-out',
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Dialog
        open={openCreateDialog}
        onClose={() => setOpenCreateDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <SimpleChannelCreate />
      </Dialog>
      <IntegrationsDialog
        open={isIntegrationsDialogOpen}
        onClose={toggleIntegrationsDialog}
      />
      <ChunksManagementDialog
        open={isChunksDialogOpen}
        onClose={() => setIsChunksDialogOpen(false)}
      />
    </>
  );
};

export default DarkNav;
